/*
 * スマホ用：「絞り込み」ボタンで、PC版と同じ絞り込み（.facets）をオーバーレイ表示する。
 * documentElement に cc-filters-open クラスを付け外しするだけ。表示はCSS側で制御。
 */
(function () {
  var ROOT = document.documentElement;

  function open() {
    ROOT.classList.add('cc-filters-open');
    var btn = document.querySelector('[data-cc-filter-open]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }
  function close() {
    ROOT.classList.remove('cc-filters-open');
    var btn = document.querySelector('[data-cc-filter-open]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cc-filter-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cc-filter-close]')) { e.preventDefault(); close(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ROOT.classList.contains('cc-filters-open')) close();
  });

  // スマホの並び替え：選んだら現在の絞り込みを保ったままその並びで表示
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('#CcSortMobile');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  });
})();
